import {getPlatformNameForStats} from "./envNameUtils.ts";
import {URL_BASE} from "../../Globals.ts";

const isOutdated = (current: string, latest: string): boolean => {
    const parseVersion = (version: string): number[] => {
        return version.split('.').map(num => parseInt(num, 10));
    };

    const [currentMajor, currentMinor, currentPatch] = parseVersion(current);
    const [latestMajor, latestMinor, latestPatch] = parseVersion(latest);

    if (latestMajor > currentMajor) return true;
    if (latestMajor < currentMajor) return false;
    if (latestMinor > currentMinor) return true;
    if (latestMinor < currentMinor) return false;

    return latestPatch > currentPatch;
};

export const checkUserVersion = async (userVersion: string, environment: string, vscode: any, setEnvironmentObj: any) => {
    const platform = getPlatformNameForStats(environment);

    try {
        const url = `${URL_BASE}/api/getLatestVersion`;

        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ environment: platform })
        });

        if (response.ok) {
            const responseData = await response.json();
            const { version } = responseData;

            setEnvironmentObj({userApplicationVersion: userVersion, latestApplicationVersion: version})

            if (isOutdated(userVersion, version)) {
                if (platform === "jetbrains") {
                    window.jetbrainsPostMessage(JSON.stringify({
                        functionName: "notifyUpdate",
                        data: [{mostRecentVersion: version}]
                    }));
                } else if (platform === "chrome") {
                    window.parent.postMessage({
                            functionName: 'notifyUpdate',
                            data: [{ mostRecentVersion: version }]
                        },
                        '*');
                } else if (platform === "vscode") {
                    vscode.postMessage({ functionName: "notifyUpdate", data: [{ mostRecentVersion: version }] });
                }
            }
        }
    } catch (error) {
        console.error(error);
    }
}

export const getUserLocation = async (setUserObj: any) => {
    try {
        const response = await new Promise<Response>((resolve, reject) => {
            setTimeout(async () => {
                try {
                    const res = await fetch(`https://ipinfo.io/json?token=${import.meta.env.VITE_IPINFO_KEY}`);
                    resolve(res);
                } catch (error) {
                    reject(error);
                }
            }, 1500);
        });

        const data = await response.json();
        setUserObj({location: `${data.city}, ${data.region}, ${data.country}`});
    } catch (error) {
        console.error('Error fetching location:', error);
        setUserObj({location: 'Location not available'});
    }
};

export const isSubscribed = (subscriptionPlan: string | null | undefined, monthlyFreeMessages: number) => {
    return subscriptionPlan !== null || monthlyFreeMessages > 0;
}
